import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b67f5dca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b67f5dca&prod&lang=stylus"
import style1 from "./index.vue?vue&type=style&index=1&id=b67f5dca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67f5dca",
  null
  
)

export default component.exports